import { ReactComponent as Svge } from "src/HomePge/assets/svg/car.svg";

function SvgComponent(props) {
  return (
    <Svge
      style={{
        width: "73px",
        backgroundPositionY: "center",
        height: "52px",
        padding: "0px"
      }}
      {...props}
    />

  );
}

export default SvgComponent;
